import { useActiveFeatureFlags, usePostHog } from 'posthog-js/react'
import type { FeatureFlag } from '../__generated__/featureFlags'

export const useFeatureFlag = () => {
  const posthog = usePostHog()
  // useActiveFeatureFlags is called for reactivity — it triggers re-renders when flags change.
  // The actual value is read via getFeatureFlag to avoid a PostHog bug where activeFlags
  // incorrectly includes 'maintenance' after any flag override is applied.
  useActiveFeatureFlags()

  const isFeatureFlagEnabled = (flag: FeatureFlag): boolean =>
    Boolean(posthog.featureFlags.getFeatureFlag(flag))

  return { isFeatureFlagEnabled }
}
